import { render, staticRenderFns } from "./PersonPrefData.vue?vue&type=template&id=eee07968"
import script from "./PersonPrefData.vue?vue&type=script&lang=js"
export * from "./PersonPrefData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports